<template>
  <div class="staff-mosaic">
    <div class="section-inner">
      <StoryblokComponent
        v-for="item in blok.items"
        :key="item._uid"
        :blok="item"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.staff-mosaic {
  .section-inner {
    display: grid;
    gap: 0.625rem;
  }

  @include for-tablet-landscape-up {
    .section-inner {
      grid-template-columns: repeat(2, 1fr);
    }

    .staff-testimonial {
      grid-column: span 2;
    }
  }
}
</style>
